import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import './Header.scss';
import history from '~/history';

class Header extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    title: PropTypes.string.isRequired,
  };

  static defaultProps = {
    className: '',
  };

  render() {
    const { className, title } = this.props;

    return (
      <div className={classnames('common-header', className)}>
        <div className="common-header__icon" onClick={() => history.goBack()}>
          <i className="fa fa-chevron-left" />
        </div>
        {title}
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/common/header/Header.js